import {
  getIconProperties
} from "./chunk.OVBRLX5Z.js";
import {
  uploader_bar_styles_default
} from "./chunk.DHSPUF4Y.js";
import {
  jsonAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  emit
} from "./chunk.C4ZTYQN4.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  s,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/uploader/uploader-bar.ts
import { t as t2 } from "i18next";
var FadvUploaderBar = class extends s {
  constructor() {
    super(...arguments);
    this.promptForCancel = false;
  }
  firstUpdated() {
    if (!this.file)
      return;
    this.handleUpdateProgressBar();
    this.handleUpdateIcon();
    emit(this, "fadv-upload-initialized", { detail: { file: this.file } });
  }
  handleUpdateIcon() {
    const iconProperties = getIconProperties(this.file.type);
    this.icon.name = iconProperties.name || "";
    this.icon.library = iconProperties.library || "";
    this.icon.foreground = iconProperties.foreground;
  }
  handleUpdateProgressBar() {
    if (!this.progressBar)
      return;
    switch (this.status) {
      case "cancelled":
        this.progressBar.processing = true;
        this.progressBar.animated = false;
        this.progressBar.variant = "warning";
        break;
      case "completed":
        emit(this, "fadv-upload-completed", { detail: { filename: this.file.name } });
        this.progressBar.processing = false;
        this.progressBar.animated = false;
        this.progressBar.variant = "primary";
        break;
      case "failed":
        emit(this, "fadv-upload-failed", { detail: { filename: this.file.name } });
        this.progressBar.processing = true;
        this.progressBar.animated = false;
        this.progressBar.variant = "danger";
        break;
      default:
        this.progressBar.processing = true;
        this.progressBar.animated = true;
        this.progressBar.variant = "neutral";
        break;
    }
  }
  retryUpload() {
    emit(this, "fadv-upload-retried", { detail: { filename: this.file.name } });
  }
  confirmCancel() {
    this.promptForCancel = false;
    const event = emit(this, "fadv-upload-cancelled", { detail: { filename: this.file.name } });
    if (!event.defaultPrevented) {
      this.status = "cancelled";
      requestAnimationFrame(() => {
        const uploader = this.closest("fadv-uploader");
        if (uploader == null ? void 0 : uploader.contains(this)) {
          uploader.removeFile(this.file);
        }
      });
    }
  }
  renderCancelButton() {
    return $`<fadv-typography class="uploader-bar__cancel-button" variant="neutral" scale="400"><fadv-button variant="text" @click=${() => this.promptForCancel = true}><fadv-icon label="${t2("components:common.cancel")}" library="solid" name="trash-can"></fadv-icon></fadv-button></fadv-typography>`;
  }
  renderUploaderBars() {
    if (this.status !== "completed")
      return w;
    return $`<div class="uploader-bar__completed"><slot></slot></div>`;
  }
  renderErrorMessageLabel() {
    if (this.status !== "failed")
      return w;
    return $`<fadv-typography class="uploader-bar__message" type="label-small" variant="danger">${t2("components:uploader.uploadFailed")}</fadv-typography>`;
  }
  renderIndicator() {
    if (this.status === "completed") {
      return $`<div class="uploader-bar__indicator"><fadv-icon library="solid" name="fa-circle-check" foreground="success"></fadv-icon></div>`;
    }
    if (this.status === "failed") {
      return $`<div class="uploader-bar__indicator"><fadv-icon library="solid" name="fa-circle-exclamation" foreground="danger"></fadv-icon><fadv-typography class="uploader-bar__retry-button" variant="danger"><fadv-button variant="text" @click=${this.retryUpload}>${t2("components:common.retry")}</fadv-button></fadv-typography></div>`;
    }
    return $`<div class="uploader-bar__indicator"><fadv-spinner></fadv-spinner></div>`;
  }
  renderCancelPrompt() {
    if (!this.promptForCancel)
      return w;
    let prompt = t2("components:uploader.confirmCancel");
    if (this.status === "processing") {
      prompt = t2("components:uploader.confirmCancelProcessing");
    }
    return $`<fadv-modal label="${t2("components:uploader.cancelPromptLabel")}" class="upload-bar__prompt" no-header open size="small" @sl-after-hide=${() => this.promptForCancel = false} ><fadv-typography variant="danger"><svg width="58" height="57" viewBox="0 0 58 57" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M29 3.625C42.4375 3.625 53.4688 14.5085 53.4688 28.0938C53.4688 41.6072 42.5246 52.5625 29 52.5625C15.4919 52.5625 4.53125 41.6238 4.53125 28.0938C4.53125 14.5903 15.4744 3.625 29 3.625ZM29 0C13.4853 0 0.90625 12.5836 0.90625 28.0938C0.90625 43.6129 13.4853 56.1875 29 56.1875C44.5147 56.1875 57.0938 43.6129 57.0938 28.0938C57.0938 12.5836 44.5147 0 29 0ZM27.6984 13.5938H30.3015C31.0744 13.5938 31.6919 14.2374 31.6597 15.0098L30.8668 34.041C30.8364 34.7692 30.2374 35.3438 29.5085 35.3438H28.4914C27.7626 35.3438 27.1635 34.7691 27.1331 34.041L26.3402 15.0098C26.3081 14.2374 26.9255 13.5938 27.6984 13.5938ZM29 37.6094C27.2482 37.6094 25.8281 39.0295 25.8281 40.7812C25.8281 42.533 27.2482 43.9531 29 43.9531C30.7518 43.9531 32.1719 42.533 32.1719 40.7812C32.1719 39.0295 30.7518 37.6094 29 37.6094Z" fill="#D20B5E" /></svg></fadv-typography><fadv-typography type="paragraph-large">${prompt}</fadv-typography><fadv-button class="upload-bar__prompt-abort" variant="neutral" slot="footer" @click=${() => this.promptForCancel = false}>${t2("components:common.no")}</fadv-button><fadv-button class="upload-bar__prompt-confirm" variant="danger" slot="footer" @click=${this.confirmCancel}>${t2("components:common.yes")}</fadv-button></fadv-modal>`;
  }
  render() {
    if (!this.file)
      return w;
    return $`<div class=${o({
      "uploader-bar": true,
      "uploader-bar--cancelled": this.status === "cancelled"
    })} ><div class="uploader-bar__content"><div class="uploader-bar__icon"><fadv-icon size="medium"></fadv-icon></div><div class="uploader-bar__name"><fadv-typography type="label-small">${this.file.name}</fadv-typography></div><div class="uploader-bar__progress"><fadv-progress-bar class="uploader-bar__progress-bar" value=${this.progress}></fadv-progress-bar>${this.renderErrorMessageLabel()}</div>${this.renderIndicator()} ${this.renderCancelButton()}</div>${this.renderUploaderBars()} ${this.renderCancelPrompt()}</div>`;
  }
};
FadvUploaderBar.styles = uploader_bar_styles_default;
__decorateClass([
  i(".uploader-bar__progress-bar")
], FadvUploaderBar.prototype, "progressBar", 2);
__decorateClass([
  i(".uploader-bar__icon fadv-icon")
], FadvUploaderBar.prototype, "icon", 2);
__decorateClass([
  e({ converter: jsonAttributeConverter })
], FadvUploaderBar.prototype, "file", 2);
__decorateClass([
  e()
], FadvUploaderBar.prototype, "status", 2);
__decorateClass([
  e()
], FadvUploaderBar.prototype, "progress", 2);
__decorateClass([
  t()
], FadvUploaderBar.prototype, "promptForCancel", 2);
__decorateClass([
  watch("status")
], FadvUploaderBar.prototype, "handleUpdateProgressBar", 1);
FadvUploaderBar = __decorateClass([
  n("fadv-uploader-bar")
], FadvUploaderBar);

export {
  FadvUploaderBar
};
